<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': bedrooms_touched}" type="button" data-toggle="dropdown">
            Quartos
        </button>

        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">Quartos</p>

            <div class="form-group">
                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bedrooms" id="bedrooms_1" v-model="model" value="1"/>
                    <label for="bedrooms_1">1</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bedrooms" id="bedrooms_2" v-model="model" value="2"/>
                    <label for="bedrooms_2">2</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bedrooms" id="bedrooms_3" v-model="model" value="3"/>
                    <label for="bedrooms_3">3</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bedrooms" id="bedrooms_4" v-model="model" value="4"/>
                    <label for="bedrooms_4">4+</label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.bedrooms || [],
        }
    },
    watch: {
        selected_bedrooms: {
            handler(newVal) {
                this.model = newVal;
            }
        }
    },
    computed: {
        selected_bedrooms() {
            return this.$store.getters.getFilter.bedrooms || [];
        },
        bedrooms_touched() {
            return this.selected_bedrooms.length > 0;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', { bedrooms: this.model });
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>

